module.exports = __webpack_public_path__ + "img/FilterAltOutlined.4e19ad3a.svg";